module.exports = __webpack_public_path__ + "static/img/30014 (1).dd97ad4.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30014 (1).webp
// module id = 7B58
// module chunks = 14